import { Cookies } from "react-cookie";
import { v4 as uuid } from "uuid";

/* eslint-disable @typescript-eslint/no-magic-numbers */
const IN_ONE_YEAR = new Date(new Date().getTime() + 24 * 3600000 * 365);
const IN_THIRTY_MINUTES = new Date(new Date().getTime() + 30 * 60000);
/* eslint-enable @typescript-eslint/no-magic-numbers */

enum CookiesName {
  SessionId = "compara.session.id",
  UserId = "comparaUserId"
}

export interface SessionCookies {
  sessionId: string;
  userId: string;
}

function getCookie(name: CookiesName): string {
  const cookies = new Cookies(document.cookie);
  return cookies.get(name) || "";
}

function setCookie(name: CookiesName, value: string, expires: Date): void {
  const cookies = new Cookies(document.cookie);
  if (!cookies.get(name)) cookies.set(name, value, { expires });
}

export const getSessionCookies = (): SessionCookies => ({
  sessionId: getCookie(CookiesName.SessionId),
  userId: getCookie(CookiesName.UserId)
});

export const setSessionCookies = (): void => {
  setCookie(CookiesName.SessionId, uuid(), IN_THIRTY_MINUTES);
  setCookie(CookiesName.UserId, uuid(), IN_ONE_YEAR);
};
